import axios from "axios";
import store from "@/store"

const instance = axios.create();

instance.interceptors.request.use(
  function (config) {
    config.baseURL = "http://" + store.state.host.ip + ":" + store.state.host.port + "/api"
    // config.withCredentials = true

    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export { instance as axios }